module.exports = __webpack_public_path__ + "static/media/image-card-10.a1785b7b.png";